/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { HelpText } from "components/help-text/HelpText";
import React, { useCallback, useMemo } from "react";

const styles = {
  checkGroup: css`
    display:inline-block;
    vertical-align: top;
    fieldset {
      border: solid black 1px;
      padding: 0;
      padding-left: 10px;
      padding-right: 10px;
      padding-bottom: 10px;
      display: inline;
      margin-left: 4px;
      margin-right: 4px;
  
      legend {
        width: auto;
        margin: 0;
        margin-left: 4px;
        padding-left: 4px;
        padding-right: 4px;
  
        &.clickable {
          cursor: pointer;
        }
      }
  
      label {
        padding: 0;
        margin: 0;
        padding-right: 10px;
      }
  
      input {
        padding: 0;
        margin: 0 5px 0 0 ;
        width: auto;
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
      }
    }
  `,

  optionContainer: css`
    overflow-x: auto;
    height: 350px;
  `
};

export const CheckGroupWithUncheckOptionSelector = <T,>( { label, helpId, options, isFixedHeight = false, uncheckOptionText, onChange }: { label: string; helpId: string; options: Array<{ value: T; name: string; isSelected: boolean; isEnabled?: boolean; }>; isFixedHeight?: boolean; uncheckOptionText: string; onChange( value: T, isSelected: boolean ): void; } ): JSX.Element => {
  const hasSelectedTypes = useMemo( () => options.filter( m => m.isSelected ).length > 0, [ options ] );

  const uncheckAll = useCallback( (): void => {
    options.map( m => onChange( m.value, false ) );
  }, [ onChange, options ] );

  return (
    <div css={ styles.checkGroup }>
      <fieldset>
        <legend><label>{ label } <HelpText helpId={ helpId } /></label></legend>
        <div><label><input type="radio" onChange={ () => uncheckAll() } checked={ !hasSelectedTypes }></input>{ uncheckOptionText }</label></div>
        <div css={ isFixedHeight ? styles.optionContainer : undefined }>
          {
            options.map( ( m, i ) => ( <CheckSelector key={ i } { ...m } isEnabled={ m.isEnabled } onChange={ onChange } /> ) )
          }
        </div>
      </fieldset>
    </div>
  );
};

const CheckSelector = <T,>( { value, name, isSelected, isEnabled = true, onChange }: { value: T; name: string; isSelected: boolean; isEnabled?: boolean; onChange: ( value: T, isSelected: boolean ) => void; } ) => {

  // deal with weird divider value
  const valueAsString = useMemo( () => {
    const valueAsString = String( value );
    return valueAsString;
  }, [ value ] );

  if ( valueAsString && valueAsString === "-1" ) {
    isEnabled = false;
  }

  return (
    <div data-key={ value }>
      <div>
        { isEnabled && <>
          <input aria-label={ name } type="checkbox" disabled={ !isEnabled } checked={ isSelected } onChange={ ( e: React.FormEvent<HTMLInputElement> ) => onChange( value, e.currentTarget.checked ) } />
        </> }
        <span onSelect={ ( e ) => { e.preventDefault(); return false; } }>{ name }</span>
      </div>
    </div>
  );
};
